import { Z_INDEX_MAX, WHITE, BRAND_BLACK, INACTIVE_GRAY, NATIONAL_TWO_REGULAR } from './constants';

const addPixelValues = (...args) => {
  const value = args?.reduce?.((acc, arg) => {
    if (arg) {
      return acc + +arg?.split('px')?.[0];
    } else {
      return acc;
    }
  }, 0);
  return isNaN(value) ? args?.[0] : `${value}px`;
};

const HEADER_STYLES = {
  desktop: {
    height: '100px',
    backgroundColor: WHITE,
    maxWidth: '1180px',
    margin: '0 auto',
    display: 'flex',
    overflowX: 'hidden',
  },
  mobile: {
    height: '45px',
  },
  classNames: {
    localized: {
      desktop: {
        top: '22px',
      },
      mobile: {
        top: '100px',
      },
    },
  },
};

const START_ORDER_STYLES = {
  desktop: {
    display: 'flex',
    backgroundColor: BRAND_BLACK,
    height: '68px',
  },
  mobile: {
    height: '118px',
    display: 'flex',
    position: 'fixed',
    width: '100%',
    bottom: '0',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '1px',
    padding: '5px',
  },
};

const START_ORDER_BTN_STYLES = {
  desktop: {
    border: '1.5px solid rgb(228, 0, 43)',
    fontFamily: NATIONAL_TWO_REGULAR,
    lineHeight: '24px',
    fontSize: '14px',
    fontWeight: 500,
  },
  mobile: {
    marginTop: '16px',
    width: '99%',
    marginBottom: '21px',
    maxWidth: '242px',
  },
};

const DISPOSITION_BAR_STYLES = {
  desktop: {
    display: 'flex',
    backgroundColor: BRAND_BLACK,
    height: '50px',
  },
  mobile: {
    height: 'fit-content',
    display: 'flex',
    width: '100%',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '1px',
    padding: '5px',
  },
};

const FOOTER_STYLES = {
  classNames: {
    localized: {
      mobile: {
        paddingBottom: '0px !important',
      },
    },
  },
};

const STICKY_TOP_VALUES = {
  desktop: {
    topLocalized: addPixelValues(HEADER_STYLES.desktop.height, DISPOSITION_BAR_STYLES.desktop.height),
    topNonLocalized: addPixelValues(HEADER_STYLES.desktop.height, START_ORDER_STYLES.desktop.height),
  },
  mobile: {
    topLocalized: HEADER_STYLES.mobile.height,
    topNonLocalized: HEADER_STYLES.mobile.height,
  },
};

const MENU_CATEGORY_STYLES_DESKTOP = {
  desktop: {
    height: '100vh',
    width: '18vw',
    position: 'sticky',
    marginLeft: '0.8%',
    top: STICKY_TOP_VALUES.desktop.topNonLocalized,
  },
  classNames: {
    localized: {
      desktop: {
        top: STICKY_TOP_VALUES.desktop.topLocalized,
      },
    },
  },
};

const MENU_CATEGORY_STYLES_MOBILE = {
  mobile: {
    flexWrap: 'nowrap !important',
    marginLeft: '0 !important',
    paddingLeft: '10px',
    paddingTop: '5px',
    borderBottom: `1px solid ${INACTIVE_GRAY}`,
    overflowY: 'hidden',
    zIndex: `${Z_INDEX_MAX - 1}`,
    width: '100%',
    backgroundColor: WHITE,
    marginTop: '0',
    marginBottom: '5px',
  },
  classNames: {
    'hide-mob-nav-row': {
      width: '0',
      height: '0',
    },
  },
};

const CONTACT_US_CONTAINER_STYLES = {
  desktop: {
    position: 'sticky',
    top: STICKY_TOP_VALUES.desktop.topNonLocalized,
  },
  classNames: {
    localized: {
      desktop: {
        top: STICKY_TOP_VALUES.desktop.topLocalized,
      },
    },
  },
};

const FAQ_CONTAINER_STYLES = {
  desktop: {
    height: 'auto',
    maxHeight: '180vh',
    width: '18vw',
    position: 'sticky',
    marginLeft: '0.8%',
    marginRight: '30px',
    top: STICKY_TOP_VALUES.desktop.topNonLocalized,
  },
  mobile: {
    position: 'sticky',
    backgroundColor: WHITE,
    top: STICKY_TOP_VALUES.mobile.topNonLocalized,
    height: 'unset',
    maxHeight: 'unset',
    width: 'unset',
    marginLeft: 'unset',
    marginRight: 'unset',
  },
  classNames: {
    localized: {
      desktop: {
        top: STICKY_TOP_VALUES.desktop.topLocalized,
      },
      mobile: {
        top: STICKY_TOP_VALUES.mobile.topLocalized,
      },
    },
  },
};

const OUR_ADS_STYLES = {
  // Used the same object to reduce duplication of lines, need to revert this if a custome style is required
  ...CONTACT_US_CONTAINER_STYLES,
};

const PRIVACY_POLICY_STYLES = {
  // Used the same object to reduce duplication of lines, need to revert this if a custome style is required
  ...CONTACT_US_CONTAINER_STYLES,
};

const TERMS_OS_USE_STYLES = {
  // Used the same object to reduce duplication of lines, need to revert this if a custome style is required
  ...CONTACT_US_CONTAINER_STYLES,
};

const PROTECTED_DISCLOSURE_STYLES = {
  // Used the same object to reduce duplication of lines, need to revert this if a custome style is required
  ...CONTACT_US_CONTAINER_STYLES,
};

const defaultExport = {
  addPixelValues,
  HEADER_STYLES,
  START_ORDER_STYLES,
  START_ORDER_BTN_STYLES,
  DISPOSITION_BAR_STYLES,
  FOOTER_STYLES,
  STICKY_TOP_VALUES,
  MENU_CATEGORY_STYLES_DESKTOP,
  MENU_CATEGORY_STYLES_MOBILE,
  CONTACT_US_CONTAINER_STYLES,
  FAQ_CONTAINER_STYLES,
  OUR_ADS_STYLES,
  PRIVACY_POLICY_STYLES,
  TERMS_OS_USE_STYLES,
  PROTECTED_DISCLOSURE_STYLES,
};

export default defaultExport;
